export default {
  Read(self, ReadSuccess, ReadFailed, dataParams) {
    return {
      data : {          
        AuthorizationToken : self.props.UserReducer.token,
        page      : dataParams.page,
        filter    : dataParams.filter,
        order     : dataParams.order,
      },
      self : self,
      onsuccess : self.ReadSuccess,
      onfailed : self.ReadFailed,
    }
  },
  Register(self, RegisterSuccess, RegisterFailed) {
    return {
      data : {          
        AuthorizationToken : self.props.UserReducer.token,
        field: {
          Type          : self.state.type,
          CompanyName   : self.state.company_name,
          Website       : self.state.website,
          CompanyPhone  : self.state.company_phone,
          Name          : self.state.name,
          Address       : self.state.address,
          Address2      : self.state.address2,
          City          : self.state.city,
          Postal        : self.state.postal,
          Phone         : self.state.phone,
          Mobile        : self.state.mobile,
          Email         : self.state.email,
          BusinessModel : self.state.business_model,
          CustomBranding: self.state.custom_branding,
          is_lite       : self.state.is_lite,
        },
      },
      self : self,
      onsuccess : self.RegisterSuccess,
      onfailed : self.RegisterFailed,
    }
  },
  Update(self, UpdateSuccess, UpdateFailed) {
    return {
      data : {
        id                 : self.state.id,
        AuthorizationToken : self.props.UserReducer.token,
        field: {
          Type          : self.state.type,
          CompanyName   : self.state.company_name,
          Website       : self.state.website,
          CompanyPhone  : self.state.company_phone,
          Name          : self.state.name,
          Address       : self.state.address,
          Address2      : self.state.address2,
          City          : self.state.city,
          Postal        : self.state.postal,
          Phone         : self.state.phone,
          Mobile        : self.state.mobile,
          Email         : self.state.email,
          BusinessModel : self.state.business_model,
          CustomBranding: self.state.custom_branding,
          is_lite       : self.state.is_lite,
        },
      },
      self : self,
      onsuccess : self.UpdateSuccess,
      onfailed : self.UpdateFailed,
    }
  },
  Detail(self, DetailSuccess, DetailFailed) {
    return {
      data : {
        id                 : self.state.id,
        AuthorizationToken : self.props.UserReducer.token,
      },
      self : self,
      onsuccess : self.DetailSuccess,
      onfailed : self.DetailFailed,
    }
  },
  UserList(action, self, readsuccess, readfailed){
    return {
      data : {
        id                 : self.props.tenantData.id,
        AuthorizationToken : self.props.UserReducer.token,
      },
      action : action,
      self : self,
      onsuccess : readsuccess,
      onfailed : readfailed,
    }
  }
}


// WEBPACK FOOTER //
// ./src/App/tenant/tenant/helper/request.props.js